const dateRegEx = /^(\d{4})(?:-(\d{1,2}))?(?:-(\d{1,2}))?$/;

export const apiDateToDateObject = (apiDateString) => {
  if (apiDateString) {
    const matches = dateRegEx.exec(apiDateString);
    if (!matches) return '';
    const [ year, month = '1', day = '1'] = matches.slice(1); // '2010-1' -> ['2010', '1', '1']w
    return new Date(year, month-1, day);
  } else {
    return null;
  }
};
